// @flow

import jquery from 'jquery';
import FroalaEditor from 'froala-editor';

(function ($) {
  FroalaEditor.PLUGINS.preserveUnlinked = function (editor: any) {
    //eslint-disable-next-line no-underscore-dangle
    function _init() {
      editor.events.on('link.beforeRemove', removeLink);
    }

    function removeLink(link) {
      var $current_image = editor.image ? editor.image.get() : null;

      if ($current_image && link) {
        return true;
      } else if (link) {
        editor.selection.save();
        $(link).replaceWith(
          $('<a />').attr('unlinked', 'true').html($(link).html())
        );
        editor.selection.restore();
        editor.popups.hide('link.edit');
      }
      return false;
    }

    return {_init};
  };
})(jquery);
